import Card from '@components/card/card';
import { LeaseConfiguratorConfig } from 'interface';

interface WhyZenAutoProps {
  data: LeaseConfiguratorConfig;
}

export const WhyZenAuto: React.FC<WhyZenAutoProps> = ({ data }) => {
  return (
    data &&
    data.whyLeaseWithZenAuto && (
      <Card data={data.whyLeaseWithZenAuto} data-cy="whyzenauto" />
    )
  );
};

export default WhyZenAuto;
